import _, { isEmpty } from 'lodash';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { useDebouncedValue } from '@mantine/hooks';
import ProductFabricContent from './ProductFabricContent';
import ProductCategorys from './ProductCategorys';
import ProductDimension from './ProductDimension';
import ProductPrice from './ProductPrice';
import ProductType from './ProductType';
import ProductVariant from './ProductVariant';
import { IconArrowLeft } from '@tabler/icons-react';
import { Accordion, Autocomplete } from '@mantine/core';
import { BASE_URL } from '../../api/EndPoints';
import { createB2BAPI } from '../../api/Interceptor';
import { validateProductDescription } from '../../utils/Validation';
import { useLoader } from '../../Context/LoaderContext';
import B2BButton from '../../components/common/B2BButton';
import B2BTabs from '../../components/common/B2BTabs';
import MappedProductType from './MappedProductType';
import MappedProductCategory from './MappedProductCategory';
import MappedProductDimentions from './MappedProductDimentions';
import MappedProductPrice from './MappedProductPrice';
import MappedProductVariant from './MappedProductVariant';
import VendorInfo from './VendorInfo';
import MapppedFabricContent from './MapppedFabricContent';
import { useLocation, useNavigate } from 'react-router-dom';
import { MappedProductContext } from '../../Context/MappedProductContext';


const CreateMappedProduct = () => {
    const location = useLocation();
      const tabinfo = location.state?.activeTab
    const vendorId = JSON.parse(localStorage.getItem('user'))?.userId;
    const { mapped, map } = location.state || {};
    const { productId } = location.state || {};
    const initialTabs = [
        { id: "1", name: "Product Type", disabled: false },
        { id: "2", name: "Category Type", disabled: true },
        { id: "3", name: "Fabric Content", disabled: true },
        { id: "4", name: "Dimensions", disabled: true },
        // { id: "5", name: "Price", disabled: true },
        { id: "5", name: "Variant", disabled: true },
        { id: "6", name: "Vendor Info", disabled: true }

    ];

    const [tabs, setTabs] = useState(initialTabs)
    const [hasMultiSelectCategoryMandatory, setHasMultiSelectCategoryMandatory] = useState([])
    const navigate = useNavigate()
    const query_param = new URLSearchParams(location.search);
    const to = query_param.get('toUrl');
    const from = query_param.get('from')
    const page = query_param.get('page');
    const size = query_param.get('size');
    const search = query_param.get('search');
    const { showLoader, hideLoader } = useLoader();


    const initialState = {
        productId: '',
        articleName: null,
        articleCode: null,
        description: '',
        supplier: '',
        isCreateBarcode: true,
        createBatch: false,
        hsnCode: '',
        mappedFabric: [],
        tags: [],
        metrics: {
            weight: 0,
            thickness: 0,
            length: 0,
            width: 0,
            inches: 0,
            centimeter: 0,
            meter: 0,
            meterSqKg: 0,
        },
        otherInformation: {
            skuPrefix: '',
            coneWeight: '',
            unitOfMeasures:
            {
                type: 'UOM',
                isRoll: true,
                isKg: false,
                isMeter: false,
                isYard: false,
            }
        },
        prodVariants: {

        },
        productVariants: [

        ],
        productCategories: {

        },
        newProductVariants: [],
        fabricContent: {
            value: "",
            composition: {}
        },
        totalProductPercent: 0,
        priceSetting: {
            isMarkUp: false,
            isMarkDown: false,
            costPrice: 0,
            markUpPercent: 0,
            markDownPercent: 0,
            sellingPrice: 0,
            mrp: 0,
            margin: 0,
        },
        categoryId: '',
        gstId: '',
        brandId: '',
        seasonId: '',
        taxonomyNode: {},
        vendorProductInfo: {
            vendorId: '',
            productId: '',
            leadTime: '',
            grayLeadTime: '',
            fabricLeadTime: '',
            costPrice: 0,
            vendorProductId: '',
            vendorProductName: '',
            supplier: '',
        },
        status: 'ACTIVE'
    }
    const [product, setProduct] = useState(initialState);
    const [imageFile, setImageFile] = useState(null)
    const [activeTab, setActiveTab] = useState("1");
    const [isFormValid, setIsFormValid] = useState(false);
    const B2B_API = createB2BAPI();
    const [status, setStatus] = useState('ACTION')
    const [copyExistingProduct, setCopyingExistingProduct] = useState([]);
    const [products, setProducts] = useState([]);
    const [inputError, setInputError] = useState([])
    const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 15 });
    const [rowCount, setRowCount] = useState(5);
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearch] = useDebouncedValue(searchTerm, 500);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedProductById, setSelectedProductById] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedProducts, setSelectedProducts] = useState([]);

    useEffect(() => {
        setIsFormValid(validateProductVariants());
    }, [product?.prodVariants, status]);

    useEffect(() => {
        fetchAllProducts();
    }, [pagination.pageIndex, pagination.pageSize, debouncedSearch])

    useEffect(() => {
        if (selectedProduct) {
            fetchProductById();
        }
    }, [selectedProduct])
    const checkDirectValue = (key) => {
        if (key === 'brandId') return true
        if (key === 'taxonomyNode') return true
    }
    useEffect(() => {
        const query_param = new URLSearchParams(location.search);
        if (productId) {
            fetchProduct(productId);
        }
    }, [location.search])
    const validateProductVariants = () => {
        return !(
            isEmpty(product?.prodVariants) ||
            !Object.values(product.prodVariants).some(variant => variant.length > 0)
        );
    };


    const handleChange = (event, fieldType, errorName, key) => {
        const value = event?.target?.type === 'checkbox' ? event?.target?.checked : event?.target?.value;
        setInputError((prev) => ({
            ...prev,
            [errorName]: ""
        }))
        if (fieldType === "articleName") {
            const { value } = event.target
        }
        if (fieldType === "hsnCode") {
            const { value } = event.target
        }
        if (fieldType === "mappedFabric") {
            setProduct(prev => ({
                ...prev,
                [key]: value
            }));
        }
        if (fieldType === "UOM") {
            const { value, checked } = event.target;

            setProduct((prevState) => {
                const updatedUnitOfMeasures = {
                    isRoll: true,
                    isKg: value === "isKg",
                    isMeter: value === "isMeter",
                    isYard: value === "isYard",
                };

                const updatedOtherInformation = {
                    ...prevState.otherInformation,
                    unitOfMeasures: updatedUnitOfMeasures,
                    kilogram: !updatedUnitOfMeasures.isKg ? "" : prevState.otherInformation.kilogram,
                    meter: !updatedUnitOfMeasures.isMeter ? "" : prevState.otherInformation.meter,
                    yard: !updatedUnitOfMeasures.isYard ? "" : prevState.otherInformation.yard,
                };

                return {
                    ...prevState,
                    otherInformation: updatedOtherInformation,
                };
            });
        }
        else if (fieldType === 'gstId') {
            setProduct(prev => ({ ...prev, gstId: event }));
        } else if (fieldType.includes('.')) {
            const [parent, child] = fieldType.split('.');
            setProduct((prev) => ({
                ...prev,
                [parent]: {
                    ...prev[parent],
                    [child]: value
                }
            }));
        } else if (['swachCardStatus', 'sellAscombo'].includes(fieldType)) {
            setProduct(prev => ({
                ...prev,
                [fieldType]: value
            }));
        } else if (fieldType === 'isCreateBarcode' || fieldType === 'createBatch') {
            setProduct(prev => ({
                ...prev,
                [fieldType]: 'true' === event?.target?.value,

            }));
        }
        else if (['sampleMOQ', 'wholesaleMOQ', 'minMargin', 'allowLoyalty', 'isStopGRN', 'isStopPurchaseReturn', 'isStopSale',
            'isAllowRefund', 'isAllowNegative', 'isAllowCostEditInGRN', 'isEnableSerialNumber', 'isNonTrading', 'metaDescription', 'productSlug', 'url', 'kilogram', 'meter', 'yard', 'coneWeight'].includes(fieldType)) {
            setProduct((prev) => {
                const updatedState = {
                    ...prev,
                    otherInformation: {
                        ...prev.otherInformation,
                        [fieldType]: value,
                    },
                };
                return updatedState;
            });
        } else if (fieldType.startsWith('variantImage')) {
            const variantIndex = fieldType.split('-')[1];

            setProduct(prev => ({
                ...prev,
                variants: prev.variants.map((variantGroup, idx) => {
                    if (idx === parseInt(variantIndex)) {
                        return variantGroup.map(variant => ({
                            ...variant,
                            image: file
                        }));
                    }
                    return variantGroup;
                })
            }));
        }
        else if (fieldType === 'seasonId') {
            setProduct((prev) => ({
                ...prev, seasonId: event
            }));
        }
        else if (fieldType === 'mappedFabric') {
            setProduct((prev) => ({
                ...prev,
                [fieldType]: event
            }))
        }
        else {
            setProduct(prev => ({
                ...prev,
                [fieldType]: checkDirectValue(fieldType) ? event : event?.target?.value,
            }));
        }
    };

    const addProduct = async (prod) => {
        try {
            showLoader();
            const res = await B2B_API.post(`product`, {
                body: prod,
            }).json();
            if (to && from) {
                return navigate(`${to}&from=${encodeURIComponent(from)}`)
            }
            setProduct(initialState);
            setImageFile(null);
            setActiveTab("1");
            notify({
                id: product?.id ? "Updated Successfully" : "Added Successfully",
                title: 'Success!!',
                message: product?.id ? "Updated Successfully" : res?.message,
                error: false,
                success: true,
            })
        } catch (err) {
            notify({
                title: 'Error!!',
                message: err?.message || 'Failed to add product.',
                error: true,
                success: false,
            })
        }
        finally {
            hideLoader();
        }
    };

    const fetchAllProducts = async () => {
        try {
            setIsLoading(true);
            const response = await B2B_API.get(`product/products/search?page=${pagination.pageIndex}&size=${pagination.pageSize}&searchTerm=${debouncedSearch}`).json();
            const data = response?.response?.content || [];
            setRowCount(response?.response?.totalElements || 0);
            setProducts(data);
        } catch (error) {
            setIsError(true);
            notify({
                id: "fetch_products",
                error: true,
                success: false,
                title: error?.message || ERROR_MESSAGE
            });
        } finally {
            setIsLoading(false);
        }
    };


   const renderComponentById = (id) => {
  switch (id) {
    case "1":
      return <MappedProductType vendorId={vendorId} />;
    case "2":
      return <MappedProductCategory vendorId={vendorId} />;
    case "3":
      return <MapppedFabricContent vendorId={vendorId} />;
    case "4":
      return <MappedProductDimentions vendorId={vendorId} />;
    case "5":
      return <MappedProductVariant vendorId={vendorId} />;
    case "6":
      return <VendorInfo vendorId={vendorId} map={map} />;
    default:
      return <ProductType />;
  }
};
    const handleTabClick = (index) => {
        handleNextTab(false)
        if (product.productId || !index.disabled) {
            setActiveTab(index.id);
        }
    };


    const handleBackTab = () => {
        const prevTabIndex = tabs.findIndex(tab => tab.id === activeTab) - 1;
        if (prevTabIndex >= 0) {
            setActiveTab(tabs[prevTabIndex].id);
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const enableNextTab = (isDisabled) => {
        setTabs((prevTabs) => {
            const updatedTabs = prevTabs.map((tab, index) => {
                if (tab.id === activeTab) {
                    const nextIndex = index + 1;
                    if (nextIndex < prevTabs.length) {
                        prevTabs[nextIndex].disabled = isDisabled;
                    }
                }
                return tab;
            });

            return [...updatedTabs];
        });
    };


    const handleNextTab = async (fromNext = true) => {
        let isValid = true;
        const errors = {};

        // switch (activeTab) {
        //     case "1":
        //         if (isEmpty(product?.articleName)) {
        //             errors.articleNameError = true;
        //             errors.articleNameErrorMessage = "Product Name is Required!";
        //             isValid = false;
        //         }
        //         if (isEmpty(product?.hsnCode)) {
        //             errors.hsnCodeNameError = true;
        //             errors.hsnCodeNameErrorMessage = "HSN Code is Required!";
        //             isValid = false;
        //         }
        //         else if (!validateProductName(product?.articleName)) {
        //             errors.articleNameError = true;
        //             errors.articleNameErrorMessage = "Special characters are not allowed!";
        //             isValid = false;
        //         } else {
        //             try {
        //                 const result = await B2B_API.get(`product/productname/${product?.articleName}`).json();

        //                 if (product?.id) {
        //                     isValid = true;
        //                 } else {
        //                     if (result?.response) {
        //                         errors.articleNameError = true;
        //                         errors.articleNameErrorMessage = "Product Name already exists";
        //                         isValid = false;
        //                     }
        //                 }
        //             } catch (error) {
        //                 console.error("Error fetching product name:", error);
        //                 errors.articleNameError = true;
        //                 errors.articleNameErrorMessage = "An error occurred while validating the product name.";
        //                 isValid = false;
        //             }
        //         }
        //         if (!validateProductDescription(product?.description)) {
        //             errors.descError = true;
        //             errors.descErrorMessage = "Please use only letters, numbers, spaces, $ , ₹ , . and ,";
        //             isValid = false;
        //         }
        //         if (!(product?.otherInformation?.unitOfMeasures?.isKg || product?.otherInformation?.unitOfMeasures?.isMeter || product?.otherInformation?.unitOfMeasures?.isYard)) {
        //             errors.uomError = true,
        //                 errors.uomErrorMessage = "UOM Is Required !!"
        //             isValid = false
        //         } else {
        //             errors.uomError = false;
        //         }
        //         if (product?.isCreateBarcode === undefined || product?.isCreateBarcode === null) {
        //             errors.barcodeError = true;
        //             errors.barcodeErrorMessage = "Barcode Is Required!!";
        //             isValid = false;
        //         } else {
        //             errors.barcodeError = false;
        //         }

        //         if (isEmpty(product?.taxonomyNode)) {
        //             errors.taxonomyError = true;
        //             errors.taxonomyErrorMessage = "Taxonomy is Required!!";
        //             isValid = false;
        //         } else {
        //             errors.taxonomyError = false;
        //         }
        //         if (product?.taxonomyNode?.name === "Rib" && isEmpty(product?.mappedFabric)) {
        //             errors.ribError = true;
        //             errors.ribErrorMessage = "Map Main Fabric is required!";
        //             isValid = false;
        //         } else {
        //             errors.ribError = false;
        //         }
        //         if (isValid) {
        //             enableNextTab(false)
        //         } else {
        //             enableNextTab(true)
        //         }

        //         break;

        //     case "2":
        //         const errorsArray = [];

        //         const isCategoryListEmpty = hasMultiSelectCategoryMandatory.filter(cat => cat.multiSelect).some(category =>
        //             !(product.productCategoriesList || []).some(prod => prod.parentId === category.categoryId)
        //         );

        //         if (isCategoryListEmpty) {
        //             errorsArray.push({
        //                 categoryError: true,
        //                 categoryErrorMessage: '',
        //                 categorysErrorMessage: 'Child fields are Required !!!',
        //             });
        //             isValid = false;
        //         }
        //         else {
        //             product?.productCategories?.forEach((pair, index) => {
        //                 if (!pair?.heirarchyLabel || pair?.heirarchyLabel.trim() === '') {
        //                     errorsArray[index] = {
        //                         categoryError: true,
        //                         categoryErrorMessage: '',
        //                         categorysErrorMessage: 'Child fields are Required !!!',
        //                     };
        //                     isValid = false;
        //                 }
        //             });
        //         }
        //         setInputError(errorsArray);
        //         if (isValid) {
        //             enableNextTab(false);
        //         } else {
        //             enableNextTab(true);
        //         }
        //         break;

        //     case "3":
        //         const isFabricContentValid = product?.fabricContent?.composition &&
        //             Object.keys(product.fabricContent.composition).length > 0 &&
        //             Object.values(product.fabricContent.composition).every(value => value);
        //         if (product?.totalProductPercent > 100 || product?.totalProductPercent < 100) {
        //             errors.fabricCompositionError = true;
        //             errors.fabricCompositionErrorMessage = "Overal composition Percentage must be 100";
        //             isValid = false;
        //         }
        //         if (!isFabricContentValid) {
        //             errors.fabricContentError = true;
        //             errors.fabricContentErrorMessage = "FCC must be selected !!";
        //             isValid = false;
        //         }
        //         if (isValid) {
        //             enableNextTab(false)
        //         } else {
        //             enableNextTab(true)
        //         }
        //         break;

        //     case "4":
        //         const { metrics } = product;
        //         const { otherInformation } = product;
        //         if (!metrics?.weight || metrics.weight <= 0) {
        //             errors.weightErrorMessage = 'Weight must be greater than zero!';
        //             isValid = false;
        //         }
        //         if (!metrics?.thickness || metrics.thickness <= 0) {
        //             errors.thicknessErrorMessage = 'Thickness must be greater than zero!';
        //             isValid = false;
        //         }
        //         if (!metrics?.width || metrics.width <= 0) {
        //             errors.widthErrorMessage = 'width must be greater than zero!';
        //             isValid = false;
        //         }
        //         if (!otherInformation?.kilogram) {
        //             errors.standardKgErrorMessage = 'STD KG must be greater than zero!';
        //             isValid = false;
        //         }
        //         if (isValid) {
        //             enableNextTab(false)

        //         } else {
        //             enableNextTab(true)
        //         }
        //         break;

        //     case "5":
        //         if (!product?.priceSetting?.isMarkUp && !product?.priceSetting?.isMarkDown) {
        //             errors.priceSettingsError = true;
        //             errors.priceSettingsErrorMessage = "Please select either Mark Up or Mark Down.";
        //             isValid = false;
        //         } else {

        //             if (product?.priceSetting?.isMarkUp) {
        //                 if (!product?.priceSetting?.costPrice || product?.priceSetting?.costPrice <= 0) {
        //                     errors.costPriceError = true;
        //                     errors.costPriceErrorMessage = "Cost Price is required!";
        //                     isValid = false;
        //                 } else {
        //                     errors.costPriceError = false;
        //                     errors.costPriceErrorMessage = "";
        //                 }

        //                 if (!product?.priceSetting?.markUpPercent || product?.priceSetting?.markUpPercent <= 0) {
        //                     errors.markUpPercentError = true;
        //                     errors.markUpPercentErrorMessage = "Mark Up Percent is required!";
        //                     isValid = false;
        //                 } else {
        //                     errors.markUpPercentError = false;
        //                     errors.markUpPercentErrorMessage = "";
        //                 }
        //             }

        //             if (product?.priceSetting?.isMarkDown) {
        //                 if (!product?.priceSetting?.mrp || product?.priceSetting?.mrp <= 0) {
        //                     errors.mrpError = true;
        //                     errors.mrpErrorMessage = "MRP is required!";
        //                     isValid = false;
        //                 } else {
        //                     errors.mrpError = false;
        //                     errors.mrpErrorMessage = "";
        //                 }

        //                 if (!product?.priceSetting?.markDownPercent || product?.priceSetting?.markDownPercent <= 0) {
        //                     errors.markDownPercentError = true;
        //                     errors.markDownPercentErrorMessage = "Mark Down Percent is required!";
        //                     isValid = false;
        //                 } else {
        //                     errors.markDownPercentError = false;
        //                     errors.markDownPercentErrorMessage = "";
        //                 }
        //             }
        //         }

        //         if (isEmpty(product?.gstId)) {
        //             errors.gstError = true;
        //             errors.gstErrorMessage = "GST must be selected!";
        //             isValid = false;
        //         }
        //         if (isValid) {
        //             enableNextTab(false)
        //         } else {
        //             enableNextTab(true)
        //         }
        //         break;
        // }

        // setInputError(prev => ({ ...prev, ...errors }));

        if (fromNext) {
            if (isValid) {
                const currentTabIndex = tabs.findIndex((tab) => tab.id === activeTab);
                const nextTabIndex = currentTabIndex + 1;
                if (nextTabIndex < tabs.length) {
                    setActiveTab(tabs[nextTabIndex].id);
                    setTabs((prevTabs) =>
                        prevTabs.map((tab, index) =>
                            index === nextTabIndex ? { ...tab, disabled: false } : tab
                        )
                    );
                }
            } else {
                const currentTabIndex = tabs.findIndex((tab) => tab.id === activeTab);
                setTabs((prevTabs) =>
                    prevTabs.map((tab, index) => ({
                        ...tab,
                        disabled: index > currentTabIndex,
                    }))
                );

                setActiveTab(activeTab);
            }
        }
      window.scrollTo({ top: 0, behavior: 'smooth' });

    }

    const convertMeterToYard = () => {
        const res = product.otherInformation.meter * 1.09632;
        return res.toFixed(2);
    }

    const handleProductSave = async () => {
        const formData = new FormData();
        let updatedProduct = {
            ...product,
            productCategories: [...product.productCategories]
        };
        updatedProduct.productVariants = product.newProductVariants;
        updatedProduct.productCategories = updatedProduct.productCategories
            ? updatedProduct.productCategories.reduce((acc, item) => {
                const value = item.value
                value.heirarchyLabel = item.heirarchyLabel
                acc[item.key] = value;
                return acc;
            }, {})
            : {};
        updatedProduct.otherInformation?.unitOfMeasures?.isMeter && (updatedProduct.otherInformation.yard = convertMeterToYard());

        delete updatedProduct.prodVariants
        formData.append("product", JSON.stringify(updatedProduct))
        formData.append("image", imageFile)
        addProduct(formData);
        navigate('/product/product/articles')
    };

    const enableAllTabs = () => {
        const updatedTabs = tabs.map((tab) => ({ ...tab, disabled: false }));
        setTabs(updatedTabs);
    };

    const fetchProductById = async () => {
        try {
            const response = await B2B_API.get(`product/${selectedProduct}`).json();
            const product = response.response;
            const barcodeString = product?.isCreateBarcode ? "true" : "false";
            const prod = product?.productVariants?.map(item => {
                return {
                    ...item,
                    variantSku: '',
                    id: null,
                    createdDate: '',
                    createdBy: '',
                    barcode: null
                }
            })

            const transformData = () => {
                const result = {};
                prod?.forEach(variant => {
                    variant.variants.forEach(v => {
                        if (!result[v.name]) {
                            result[v.name] = new Set();
                        }
                        result[v.name].add(v.id);
                    });
                });

                for (const key in result) {
                    result[key] = Array.from(result[key]);
                }

                return result;
            };

            const calculateTotalPercent = (composition) => {
                return Object.values(composition).reduce((sum, value) => sum + parseInt(value, 10), 0);
            };
            const fetchHeirarchy = async (parentId) => {
                let heirarchy = [];
                let currentId = parentId;
                while (currentId) {
                    try {
                        const res = await B2B_API.get(`product-category/category/${currentId}`).json();
                        const category = res.response;
                        if (category) {
                            heirarchy.push(category.name);
                            currentId = category.parentId;
                        } else {
                            currentId = null;
                        }
                    } catch (error) {
                        console.error('Error category : ', error);
                        currentId = null;
                    }
                }
                return heirarchy.reverse();
            }

            const transformCategories = async () => {
                const result = [];

                for (const [key, value] of Object.entries(product?.productCategories || {})) {
                    const heirarchy = await fetchHeirarchy(value.categoryId);
                    const heirarchyLabel = heirarchy?.slice(1).join('/');
                    result.push({
                        key: key,
                        value: value,
                        heirarchyLabel: heirarchyLabel,
                        options: value.options || [],
                        openModal: false
                    });
                }
                return result;
            };

            const adjustPriceSetting = (priceSetting) => {
                return {
                    ...priceSetting,
                    id: null,
                    priceSettingId: null,
                    isMarkDown: priceSetting?.markDownPercent > 0 ? true : false,
                    isMarkUp: priceSetting?.markUpPercent > 0 ? true : false,
                };
            };

            setProduct({
                ...product,
                articleCode: null,
                articleName: null,
                id: null,
                productId: '',
                tags: product?.productTags?.split(",").map(tag => tag.trim()),
                brandId: product?.brand?.brandId,
                taxonomy: product?.taxonomy?.name,
                barcode: barcodeString,
                gstId: product?.gst?.gstId,
                seasonId: product?.season?.id,
                productCategories: await transformCategories(),
                metrics: {
                    ...product?.metrics,
                    id: null
                },
                otherInformation: {
                    ...(product?.otherInformation || {}),
                    id: null,
                    unitOfMeasures: {
                        ...(product?.otherInformation?.unitOfMeasures || {}),
                        id: null
                    }
                },
                prodVariants: transformData(),
                newProductVariants: prod,
                productVariants: prod,
                mappedFabric: [],
                priceSetting: adjustPriceSetting(product?.priceSetting),
                totalProductPercent: product?.fabricContent?.composition && calculateTotalPercent(product?.fabricContent?.composition),
            });
        }
        catch (err) {
            notify({
                title: 'Error!',
                message: err?.message || 'Failed to fetch product.',
                error: true,
                success: false,
            });
        }
    }

    const fetchProduct = async (id) => {
        try {
            let response;
            if (map) {
                response = await B2B_API.get(`product/mappedProductByVendor?vendorId=${vendorId}&productId=${id}`).json();
            }
            else {
                response = await B2B_API.get(`product/${id}`).json();
            };
            const product = response.response;
            setSelectedProductById(product)
            const barcodeString = product?.isCreateBarcode ? "true" : "false";
            enableAllTabs()
            const transformData = () => {
                const result = {};
                product?.productVariants.forEach(variant => {
                    variant.variants.forEach(v => {
                        if (!result[v.name]) {
                            result[v.name] = new Set();
                        }
                        result[v.name].add(v.id);
                    });
                });

                for (const key in result) {
                    result[key] = Array.from(result[key]);
                }

                return result;
            };

            const calculateTotalPercent = (composition) => {
                return Object.values(composition).reduce((sum, value) => sum + parseInt(value, 10), 0);
            };
            const fetchHeirarchy = async (parentId) => {
                let heirarchy = [];
                let currentId = parentId;
                while (currentId) {
                    try {
                        const res = await B2B_API.get(`product-category/category/${currentId}`).json();
                        const category = res.response;
                        if (category) {
                            heirarchy.push(category.name);
                            currentId = category.parentId;
                        } else {
                            currentId = null;
                        }
                    } catch (error) {
                        console.error('Error category : ', error);
                        currentId = null;
                    }
                }
                return heirarchy.reverse();
            }

            const transformCategories = async () => {
                const result = [];

                for (const [key, value] of Object.entries(product?.productCategories || {})) {
                    const heirarchy = await fetchHeirarchy(value.categoryId);
                    const heirarchyLabel = heirarchy?.slice(1).join('/');
                    result.push({
                        key: key,
                        value: value,
                        heirarchyLabel: heirarchyLabel,
                        options: value.options || [],
                        openModal: false
                    });
                }
                return result;
            };

            const adjustPriceSetting = (priceSetting) => {
                return {
                    ...priceSetting,
                    isMarkDown: priceSetting?.markDownPercent > 0 ? true : false,
                    isMarkUp: priceSetting?.markUpPercent > 0 ? true : false,
                };
            };

            setProduct({
                ...product,
                tags: product?.productTags?.split(",").map(tag => tag.trim()),
                brandId: product?.brand?.brandId,
                taxonomy: product?.taxonomy?.name,
                barcode: barcodeString,
                gstId: product?.gst?.gstId,
                seasonId: product?.season?.id,
                image: `${BASE_URL.replace("/api", "")}${product?.image}?time=${Date?.now()}`,
                productCategories: await transformCategories(),
                prodVariants: transformData(),
                newProductVariants: product?.productVariants,
                priceSetting: adjustPriceSetting(product?.priceSetting),
                totalProductPercent: product?.fabricContent?.composition && calculateTotalPercent(product?.fabricContent?.composition)
            });
        } catch (err) {
            notify({
                title: 'Error!',
                message: err?.message || 'Failed to fetch product.',
                error: true,
                success: false,
            });
        }
    };

    const handleCancel = () => {
        return navigate(`/VendorProducts`, { state: { tabinfo } });
    }

    return (
        <>
            <MappedProductContext.Provider value={{ product, handleChange, addProduct, setProduct, imageFile, setImageFile, inputError, setInputError, setHasMultiSelectCategoryMandatory, selectedProducts }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' ,marginTop:'2rem',marginBottom:'1rem' }}>
                    <h1 style={{display:'flex',fontSize:'20px',fontWeight:'bold',color:"#8BC53F" ,marginLeft:'1rem'}}>{product?.articleName}</h1>
                    <div style={{ display: "flex", gap: '1rem' }}>
                        {(!vendorId && !product?.productId) && <Autocomplete
                            data={products.map(item => ({
                                label: item?.articleName,
                                value: item?.productId
                            }))}
                            value={searchTerm}
                            onChange={(value) => setSearchTerm(value)}
                            placeholder="Copy Product"
                            clearable
                            className="input-textField"
                            label="Copy Products"
                            withinPortal
                            onSearchChange={setSearchTerm}
                            onOptionSubmit={setSelectedProduct}
                        />}

                        <B2BButton style={{ color: '#000',marginRight:'1rem' }} name="Back" onClick={() => handleCancel()} leftSection={<IconArrowLeft size={15} />} color={"#c9e8b8"} />
                    </div>
                </div>
             <Accordion
 value={activeTab}
        onChange={setActiveTab}
        variant="separated"
        styles={{
          control: {
            border: '1px solid #ccc',
            padding: '0.5rem',
          },
          item: {
            marginTop: '1rem',
            marginBottom:'2rem',
          },
        }}
>
  {tabs.map((tab) => (
    <Accordion.Item key={tab.id} value={tab.id}>
      <Accordion.Control
        disabled={tab.disabled}
       styles={{
                  label: {
                    fontSize: '20px',
                    textAlign: 'left',
                    fontWeight: 'bold',
                    width: '100%',
                    color: activeTab === tab.id ? '#8BC53F' : 'black',
                  },
                  control: {
                    border: activeTab === tab.id ? '0px solid #ccc' : '1px solid #ccc',
                  },
                }}
      >
        {tab.name}
      </Accordion.Control>

      <Accordion.Panel>
        {/* Render the correct panel for this tab */}
        {renderComponentById(tab.id)}
      </Accordion.Panel>
    </Accordion.Item>
  ))}
</Accordion>
                {/* <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
                    {product?.productId && activeTab < "6" ?
                        <B2BButton
                            name={"Update"}
                            id={"Save"}
                            onClick={handleProductSave}
                            style={{ backgroundColor: 'green' }}
                            disabled={true}
                        /> : ''}

                </div> */}
                {/* <div style={{ minHeight: '50vh' }}>
                <div className='productType-btn' style={{ display: 'flex', justifyContent: 'center', gap: '2rem', marginTop: '1rem', marginBottom: '5rem' }}>
                    {activeTab > "1" && <B2BButton name={'Prev'} onClick={handleBackTab} style={{ backgroundColor: '#8BC53F' }} />}
                    {activeTab < "6" && <B2BButton name={'Next'} onClick={handleNextTab} style={{ backgroundColor: '#8BC53F' }} />}
                </div>
                   </div> */}
            </MappedProductContext.Provider>
        </>

    );
};
export default CreateMappedProduct;



